import { Button, Modal, Form, Select, Space } from 'antd';
import { t } from 'i18next';
import IconSuccess from '../../../../../assets/Images/icons/icon-success';

const ModalChangeStatus = ({
    open,
    title = t('dataFlow.Send to review'),
    handelClose,
    handelReviewerOk,
    loading,
    width = 135,
    icon = <IconSuccess />,
    confirmText = null,
    cancelText = null,
    userOptions
}) => {
    const [form] = Form.useForm();

    const onFinish = async (values) => {
        await handelReviewerOk(form.getFieldValue('assignee'));
        form.resetFields();
    };
    return (
        <Modal
            width={455}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                {icon}
                <div className="text-2xl font-semibold whitespace-pre-line">
                    {title}
                </div>
                <Form
                    form={form} layout="vertical"
                    className='w-full'
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="assignee"
                        label={t('dataFlow.Choose reviewer')}
                        rules={[
                            {
                                required: true,
                                message: t('dataFlow.Please Choose Reviewer'),
                            },
                        ]}
                        className='text-left'
                    >
                        <Select
                            size="large"
                            className="w-full"
                            placeholder={t('dataFlow.Choose reviewer')}
                            optionFilterProp="children"
                        >
                            {userOptions.map((item) => (
                                <Select.Option
                                    key={item.userId}
                                    value={item.userId}
                                >
                                    {item.fullName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item className="flex justify-center mt-4 mb-0">
                        <Space>
                            <div className="flex justify-center items-center space-x-4">
                                <>
                                    <Button
                                        style={{ width }}
                                        type="primary"
                                        onClick={handelClose}
                                        size="large"
                                        ghost
                                        className="w-36"
                                    >
                                        {cancelText ? cancelText : t('common.Cancel')}
                                    </Button>

                                    <Button
                                        htmlType="submit"
                                        style={{ width }}
                                        loading={loading}
                                        size="large"
                                        type="primary"
                                        className="w-36"
                                    >
                                        {confirmText ? confirmText : t('common.Confirm')}
                                    </Button>
                                </>
                            </div>
                        </Space>
                    </Form.Item>
                </Form>
            </div>

        </Modal>
    );
};
export default ModalChangeStatus;
